import store from '../store/index.js'

export default {
   processStripePayment (paymentMethod, cart) {
      return axios.post(process.env.VUE_APP_ROOT_API + '/stripe/authorize-payment', {
        paymentMethod: paymentMethod,
        cart: cart
      }
      ).then(response => {
        return response.data;
      }).catch(error => {
        console.log(error);
      })
  },
  confirmStripePayment (paymentIntent, cart) {
     return axios.post(process.env.VUE_APP_ROOT_API + '/stripe/confirm-payment', {
       paymentIntent: paymentIntent,
       cart: cart
     }
     ).then(response => {

       // mutate order in store
       store.commit('mutateOrder', response.data.order)
       store.commit('mutateInvoice', response.data.invoice)

       return response.data;
     }).catch(error => {
       console.log(error);
     })
 }
}
